module.exports = __webpack_public_path__ + "img/Capability_analysis.7ac2ba11.png";